// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_BuscaCategoriasDespesasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Despesas_BuscaCategoriasDespesasRow } from './Despesas_BuscaCategoriasDespesasRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Despesas_BuscaCategoriasDespesasResponseDados = Despesas_BuscaCategoriasDespesasRow[];

export type Despesas_BuscaCategoriasDespesasResponse = ApiResponse<Despesas_BuscaCategoriasDespesasResponseDados>;

registerResponseContract('Despesas_BuscaCategoriasDespesasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      Valor: { type: 'number',  required: true },
      Nome:  { type: 'string',  required: true },
    },
  },
})
